import { resolveBuiltInEdgelessTemplateSemanticSpec } from '@affine/templates/edgeless-semantics';

import type { ChatContextValue } from '../components/ai-chat-content';
import type { CanvasSelectionItem } from '../components/ai-chat-content/type';
import {
  flattenCanvasSelectionItems,
  organizeCanvasSelectionItems,
} from './canvas-selection-areas';

export interface BuildCanvasSelectionContextInput {
  docId: string;
  label: string;
  items: CanvasSelectionItem[];
  source: ChatContextValue['canvasSelections'][number]['source'];
  priority: ChatContextValue['canvasSelections'][number]['priority'];
  templateName?: string | null;
}

export function buildCanvasSelectionContextFromItems({
  docId,
  label,
  items,
  source,
  priority,
  templateName,
}: BuildCanvasSelectionContextInput):
  | ChatContextValue['canvasSelections'][number]
  | null {
  if (!items.length) return null;

  const templateSpec = resolveBuiltInEdgelessTemplateSemanticSpec({
    templateName,
    items,
  });
  const organizedItems = organizeCanvasSelectionItems(items, {
    templateSpec,
  });
  const flatItems = flattenCanvasSelectionItems(organizedItems);

  return {
    docId,
    label,
    elementIds: flatItems
      .filter(item => item.kind === 'canvas_element')
      .map(item => item.id),
    blockIds: flatItems
      .filter(item => item.kind === 'block')
      .map(item => item.id),
    items: organizedItems,
    source,
    priority,
  };
}
